/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_Aborted_ToastInputs */

const en_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Aborted`)
};

const fr_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation annulée`)
};

const de_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgebrochen`)
};

const it_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione interrotta`)
};

const ru_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт прерван`)
};

const es_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación abortada`)
};

const zh_cn2_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出已中止`)
};

const ja_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートが中止されました`)
};

const hi_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात रद्द कर दिया गया`)
};

const pt_pt2_dialogue_list_export_aborted_toast = /** @type {(inputs: Dialogue_List_Export_Aborted_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação abortada`)
};

/**
* | output |
* | --- |
* | "Export Aborted" |
*
* @param {Dialogue_List_Export_Aborted_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_aborted_toast = /** @type {((inputs?: Dialogue_List_Export_Aborted_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_Aborted_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_dialogue_list_export_aborted_toast(inputs)
	if (locale === "de") return de_dialogue_list_export_aborted_toast(inputs)
	if (locale === "it") return it_dialogue_list_export_aborted_toast(inputs)
	if (locale === "ru") return ru_dialogue_list_export_aborted_toast(inputs)
	if (locale === "es") return es_dialogue_list_export_aborted_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_dialogue_list_export_aborted_toast(inputs)
	if (locale === "ja") return ja_dialogue_list_export_aborted_toast(inputs)
	if (locale === "hi") return hi_dialogue_list_export_aborted_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_dialogue_list_export_aborted_toast(inputs)
	return en_dialogue_list_export_aborted_toast(inputs)
});